/* eslint-disable react/prop-types */
import React, { FC } from 'react';
import {
  AutoSizer, List, ListRowProps,
} from 'react-virtualized';

type ProductListItemRenderer = (props: ListRowProps, product: any) => JSX.Element;

interface ProductListProps {
  products: any[],
  renderer: ProductListItemRenderer,
  listHeight: number,
  rowHeight: number,
}

const ProductList: FC<ProductListProps> = (props) => {
  const {
    products, renderer, listHeight, rowHeight,
  } = props;
  const rowCount = products?.length ?? 0;
  return (
    <AutoSizer disableHeight>
      {({ width }) => (
        <List
          height={listHeight}
          overscanRowCount={20}
          noRowsRenderer={() => <div>Nothing</div>}
          rowCount={rowCount}
          rowHeight={rowHeight}
          rowRenderer={(listProps) => renderer(listProps, products[listProps.index])}
          width={width}
        />
      )}
    </AutoSizer>
  );
};

export default ProductList;
